import { createContext, useContext } from 'react';

/** The moment the page looks at the data as of (a time in the past), or null for now. */
export const AsOfContext = createContext<number | null>(null);

/** Now, or the moment the page looks at the data as of: what ages are measured against. */
export function useNow(): number {
  return useContext(AsOfContext) ?? Date.now();
}
